import { HorizontalFormFieldStyle } from "../../formFieldLabelPositioning/styles/FormFieldsStyle";
import type { FieldMethod, FormFieldFactoryProps } from "../../types/types";
import { InputGenerator } from "./index";

export const InputGeneratorField: FieldMethod = ({ field, readOnly, rules }: FormFieldFactoryProps) => {
    return (
        <HorizontalFormFieldStyle key={`${field.name}FormItem`} name={field.name} rules={rules}>
            <InputGenerator key={field.name} name={field.name} label={field.translationKeys.label} readOnly={readOnly} />
        </HorizontalFormFieldStyle>
    );
};
